import React, { FunctionComponent } from "react";
import { View, Text } from "@react-pdf/renderer";

const ItemsHeader: FunctionComponent = () => (
  <View
    style={{
      display: "flex",
      flexDirection: "row",
      alignItems: "baseline",
      fontSize: "10px",
      width: "100%",
      fontFamily: "Mont-Bold",
    }}
  >
    <Text
      style={{
        paddingBottom: "8px",
        paddingTop: "8px",
        width: "7%",
        textAlign: "center",
        borderLeft: "0.505944px solid #B1B1B1",
      }}
    >
      Cant.
    </Text>
    <Text
      style={{
        paddingBottom: "8px",
        paddingTop: "8px",
        width: "13%",
        textAlign: "center",
      }}
    >
      Cod.
    </Text>
    <Text
      style={{
        width: "60%",
        display: "flex",
        flexDirection: "row",
        paddingBottom: "8px",
        paddingTop: "8px",
      }}
    >
      Detalle
    </Text>
    <Text
      style={{
        paddingBottom: "8px",
        paddingTop: "8px",
        width: "10%",
        borderRight: "0.505944px solid #B1B1B1",
        textAlign: "center",
      }}
    >
      <Text>Peso{"\n"}</Text>
      <Text>Aprox.</Text>
    </Text>
    <Text
      style={{
        paddingBottom: "8px",
        paddingTop: "8px",
        width: "10%",
        textAlign: "center",
        borderRight: "0.505944px solid #B1B1B1",
      }}
    >
      <Text>Valor{"\n"}</Text>
      <Text>Hechura</Text>
    </Text>
  </View>
);

export default ItemsHeader;
